// Money arithmetic in JS accumulates binary floating-point error (300 - 277.2 =
// 22.80000000000001). Round every computed amount to cents before storing it in
// state or rendering it, so the value itself is clean and not just its display.
//
// The shift is done through the decimal exponent instead of `* 100`, because the
// multiplication reintroduces the very error we are removing: 1.005 * 100 is
// 100.49999999999999, so `Math.round(amount * 100) / 100` would yield 1 for a
// value that must round to 1.01. Ties go up (`Math.round` semantics), which for
// negative amounts means toward zero: -1.005 rounds to -1.
export const roundToCents = (amount: number) => Number(`${Math.round(Number(`${amount}e2`))}e-2`);

// El BE puede mandar dinero como string (violación runtime del tipo TS, TKCN-543/542).
// Coerción canónica para ARITMÉTICA de montos: number finito, o `fallback` (0) si el
// valor no parsea (null, undefined, '', '1,155.00', basura). Toda suma de montos que
// pueda recibir el payload crudo debe pasar por aquí: `+` con un string CONCATENA
// ('540.00' + '135' → '540.00135') en vez de sumar.
export const toFiniteAmount = (value: unknown, fallback = 0): number => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : fallback;
  if (typeof value === 'string' && value.trim() !== '') {
    const numeric = Number(value);
    if (Number.isFinite(numeric)) return numeric;
  }
  return fallback;
};

export const formatToCurrency = (amount: number | string | null | undefined, maximumFractionDigits = 2) => {
  // Un monto AUSENTE no es $0.00: celda vacía para que el dato faltante se note,
  // en vez de inventar un cero con autoridad (Number('') y Number(null) son 0).
  if (amount === null || amount === undefined || (typeof amount === 'string' && amount.trim() === '')) {
    return '';
  }

  const numeric = typeof amount === 'number' ? amount : Number(amount);

  if (!Number.isFinite(numeric)) {
    return String(amount);
  }

  const options = {
    style: 'currency',
    currency: 'MXN',
    maximumFractionDigits,
  } as const;

  return numeric.toLocaleString('es-MX', options);
};
